import {EventEmitter, Injectable} from "@angular/core";
import {SearchPageInterface} from "./search-page.interface";
import {Observable, of, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SearchPageBaseService implements SearchPageInterface {

  private _searchTxt: string;
  private _searchTxtChange = new Subject<string>();

  constructor() {}

  search(searchTxt: string, params): Observable<any[]> {
    return of([]);
  }

  get searchTxtEvent(){
    return this._searchTxtChange.asObservable();
  }

  set searchTxt(txt: string){
    this._searchTxt = txt;
    this._searchTxtChange.next(this._searchTxt);
  }

  get searchTxt(){
    return this._searchTxt;
  }

}
